export default {
    namespaced: true,
    state: () => ({
        ThongTinNhomThe: {
            IdLoaiThe: null,
            TenNhomThe: null,
        },
        DanhSachLoaiThe: [],
    }),
    getters: {},

    mutations: {
        Set: (state, { key, data }) => {
            state[key] = data;
        },
        Reset_ThongTinNhomThe: (state) => {
            state.ThongTinNhomThe = {
                IdLoaiThe: null,
                TenNhomThe: null,
            };
        },
    },

    actions: {
        LayDanhSachNhomThe(store) {
            store;
            let defaultData = {
                data: [],
                groupCount: 0,
                summary: [0],
                totalCount: 0,
            };
            var load = this.$Helper.Common.DevExDataSourceCustom(
                async (loadOptions) => {
                    this.startLoading();
                    try {
                        let resp = await this.$Core.Api.Make(
                            this.$i18n.global.t("url.DanhSachNhomThe")
                        ).Post(loadOptions);

                        if (resp.Data.status) {
                            let data =
                                resp.Data.data && resp.Data.data.data
                                    ? resp.Data.data
                                    : defaultData;
                            return data;
                        } else return defaultData;
                    } catch (ex) {
                        if (ex.message == "Network Error")
                            throw Error("Không kết nối được đến máy chủ!");
                        throw ex;
                    } finally {
                        this.stopLoading();
                    }
                },
                "IdNhomThe" || null,
                async (key) => {
                    try {
                        let resp = await this.$Core.Api.Make(
                            this.$i18n.global.t("url.DanhSachNhomThe")
                        ).Post({
                            filter: ["IdNhomThe", "=", key],
                        });
                        if (resp.StatusCode === 200) {
                            let data =
                                (resp.Data.data?.data || []).length > 0
                                    ? resp.Data.data.data[0]
                                    : {};
                            return data;
                        } else {
                            return {};
                        }
                    } catch (ex) {
                        if (ex.message == "Network Error")
                            throw Error("Không kết nối được đến máy chủ!");
                        throw ex;
                    }
                }
            );
            return load;
        },

        async LayDanhSachLoaiThe(store) {
            try {
                let rs = await this.$Core.Api.Make(
                    this.$i18n.global.t("url.DanhSachLoaiThe")
                ).Get();
                if (rs.Data.status) {
                    store.state.DanhSachLoaiThe = rs.Data.data;
                }
                return rs.Data;
            } catch (error) {
                console.log("error", error);
            }
        },

        async TaoMoiNhomThe(store) {
            try {
                let rs = await this.$Core.Api.Make(
                    this.$i18n.global.t("url.TaoMoiNhomThe")
                ).Post(store.state.ThongTinNhomThe);
                return rs.Data;
            } catch (error) {
                console.log("error", error);
            }
        },
        async CapNhatNhomThe(store) {
            try {
                let dataPost = {
                    IdNhomThe: store.state.ThongTinNhomThe.IdNhomThe,
                    IdLoaiThe: store.state.ThongTinNhomThe.IdLoaiThe,
                    TenNhomThe: store.state.ThongTinNhomThe.TenNhomThe,
                };
                let rs = await this.$Core.Api.Make(
                    this.$i18n.global.t("url.CapNhatNhomThe")
                ).Put(dataPost);
                return rs.Data;
            } catch (error) {
                console.log("error", error);
            }
        },

        async XoaNhomThe({ state }, IdNhomThe) {
            try {
                let rs = await this.$Core.Api.Make(
                    this.$i18n.global.t("url.NhomThe") + `/${IdNhomThe}`
                ).Delete();
                return rs.Data;
            } catch (error) {
                console.log("error", error);
            }
        },
    },
};
